// Résultat d'une tâche « process » validée par la boutique : réalisée sans souci, ou avec un
// problème signalé (commentaire optionnel). Colonne `completion_status` de `store_process_tasks`.
export const storeTaskCompletionStatuses = ['WITHOUT_ISSUES', 'WITH_ISSUES'] as const
export type StoreTaskCompletionStatus = (typeof storeTaskCompletionStatuses)[number]

export const storeTaskCompletionStatusLabel: Record<StoreTaskCompletionStatus, string> = {
  WITHOUT_ISSUES: 'Sans problème',
  WITH_ISSUES: 'Avec problème',
}
